const doc = [({"en":({"adminComponentHotelFilter":({"addFilter":"Add filter", "hotelFilterTitle":"Filter settings"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;